var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFindError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 152,
    viewBox: "0 0 126 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.8922 88.5671L54.5352 85.4248L45.5954 106.356L52.9524 109.498L61.8922 88.5671Z",
    fill: "#A9C8FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8922 88.5671L54.5352 85.4248L45.5954 106.356L52.9524 109.498L61.8922 88.5671Z",
    stroke: "#3F66BA",
    strokeWidth: 3.95,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3473 88.9968C77.4652 97.5893 100.74 88.2462 109.332 68.1284C117.925 48.0105 108.582 24.7362 88.4637 16.1436C68.3458 7.55108 45.0715 16.8942 36.4789 37.012C27.8864 57.1299 37.2295 80.4042 57.3473 88.9968Z",
    fill: "#A9C8FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4514 16.1712C87.0713 15.5825 85.6586 15.0735 84.2202 14.6467C92.6738 19.4556 99.0621 27.2072 102.167 36.4238C105.272 45.6404 104.877 55.6775 101.057 64.6215C97.2372 73.5655 90.2593 80.791 81.4539 84.9204C72.6484 89.0499 62.6312 89.7946 53.312 87.0125C54.6119 87.7552 55.9533 88.4225 57.3298 89.0112C62.1285 91.1523 67.3051 92.3172 72.5584 92.438C77.8116 92.5589 83.0364 91.6333 87.9284 89.7151C92.8204 87.797 97.2819 84.9247 101.053 81.2655C104.824 77.6063 107.829 73.2333 109.894 68.4012C111.958 63.5692 113.041 58.3747 113.078 53.1202C113.116 47.8657 112.107 42.6563 110.112 37.7954C108.116 32.9344 105.173 28.5192 101.455 24.8067C97.7358 21.0942 93.3157 18.1587 88.4514 16.1712Z",
    fill: "#A8C8FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.629 83.6536C76.7959 90.9858 96.6564 83.0131 103.989 65.8462C111.321 48.6792 103.348 28.8187 86.1812 21.4865C69.0142 14.1544 49.1537 22.127 41.8216 39.294C34.4894 56.4609 42.462 76.3214 59.629 83.6536Z",
    fill: "#F4F8FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3473 88.9968C77.4652 97.5893 100.74 88.2462 109.332 68.1284C117.925 48.0105 108.582 24.7362 88.4637 16.1436C68.3458 7.55108 45.0715 16.8942 36.4789 37.012C27.8864 57.1299 37.2295 80.4042 57.3473 88.9968Z",
    stroke: "#3F66BA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3829 83.4431C76.5499 90.7753 96.4103 82.8027 103.743 65.6357C111.075 48.4688 103.102 28.6083 85.9351 21.2761C68.7681 13.9439 48.9077 21.9166 41.5755 39.0835C34.2433 56.2505 42.2159 76.111 59.3829 83.4431Z",
    stroke: "#3A5EB6",
    strokeWidth: 1.98,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.425 109.848C61.6138 104.724 59.2338 98.7948 54.1092 96.606C48.9845 94.4172 43.0557 96.7972 40.8669 101.922L32.0096 122.66C29.8208 127.784 32.2008 133.713 37.3255 135.902C42.4502 138.091 48.379 135.711 50.5678 130.586L59.425 109.848Z",
    fill: "#EDAAA9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.425 109.848C61.6138 104.724 59.2338 98.7948 54.1092 96.606C48.9845 94.4172 43.0557 96.7972 40.8669 101.922L32.0096 122.66C29.8208 127.784 32.2008 133.713 37.3255 135.902C42.4502 138.091 48.379 135.711 50.5678 130.586L59.425 109.848Z",
    stroke: "#3A5EB6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8672 101.922L59.4161 109.844",
    stroke: "#3F66BA",
    strokeWidth: 1.98,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0078 122.66L50.566 130.586",
    stroke: "#3F66BA",
    strokeWidth: 1.98,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9271 45.9277C65.5365 46.3182 65.5365 46.9514 65.9271 47.3419L71.5839 52.9987L65.927 58.6556C65.5365 59.0461 65.5365 59.6793 65.927 60.0698C66.3175 60.4604 66.9507 60.4604 67.3412 60.0698L72.9981 54.4129L78.655 60.0698C79.0455 60.4603 79.6787 60.4603 80.0692 60.0698C80.4597 59.6793 80.4597 59.0461 80.0692 58.6556L74.4123 52.9987L80.0692 47.3419C80.4597 46.9514 80.4597 46.3182 80.0692 45.9277C79.6786 45.5372 79.0455 45.5372 78.6549 45.9277L72.9981 51.5845L67.3413 45.9277C66.9508 45.5372 66.3176 45.5371 65.9271 45.9277Z",
    fill: "#3F66BA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindError);
export default __webpack_public_path__ + "static/media/find-error.f33f1acae5558c9217e6b033444a84be.svg";
export { ForwardRef as ReactComponent };